import React from 'react';
import { HeartPulseIcon, SparklesIcon, TrendingUpIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function NichoSection() {
  const niches = [{
    icon: <HeartPulseIcon className="w-6 h-6 text-turquoise" data-id="element-176" />,
    title: 'Salud y Bienestar',
    description: 'Médicos, Dentistas y Nutricionistas buscando automatizar su agenda.',
    gradient: 'from-teal-900/60 to-petrol',
    image: 'https://cdn.magicpatterns.com/uploads/x498Jph1ZfQBawkQDKXy44/pasted-image.webp'
  }, {
    icon: <SparklesIcon className="w-6 h-6 text-turquoise" data-id="element-177" />,
    title: 'Cuidado Personal',
    description: 'Clínicas de estética y Barberías de autor que necesitan imagen premium.',
    gradient: 'from-cyan-900/60 to-petrol',
    image: 'https://cdn.magicpatterns.com/uploads/btyJRZUNxDXRGkkCLLBxYi/pasted-image.jpg'
  }, {
    icon: <TrendingUpIcon className="w-6 h-6 text-turquoise" data-id="element-178" />,
    title: 'Finanzas y Negocios',
    description: 'Asesores financieros buscando captar leads calificados.',
    gradient: 'from-blue-900/60 to-petrol',
    image: 'https://cdn.magicpatterns.com/uploads/oZcrw99CZa7y4f7w7wYiay/asesor-financiero-vs-asesor-bancario-semejanzas-y-diferencias.jpg'
  }];
  return <section id="nicho" className="py-24 bg-petrol-light relative border-y border-petrol-lighter overflow-hidden" data-id="element-179">
      {/* Techy background lines */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-turquoise/20 to-transparent" data-id="element-180"></div>
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-turquoise/20 to-transparent" data-id="element-181"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-182">
        <FadeIn className="text-center mb-16" data-id="element-183">
          <div className="inline-flex items-center gap-2 mb-4" data-id="element-184">
            <span className="w-8 h-px bg-turquoise" data-id="element-185"></span>
            <span className="text-turquoise text-sm font-semibold tracking-widest uppercase" data-id="element-186">
              Showcase
            </span>
            <span className="w-8 h-px bg-turquoise" data-id="element-187"></span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-188">
            Soluciones Diseñadas para Líderes de Sector
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-189">
          {niches.map((niche, index) => <FadeIn key={index} delay={index * 0.2} className="group bg-petrol rounded-2xl border border-petrol-lighter hover:border-turquoise/40 transition-all duration-500 overflow-hidden shadow-lg hover:shadow-[0_10px_40px_-10px_rgba(0,212,170,0.15)] flex flex-col" data-id="element-190">
              {/* Image Placeholder Area */}
              <div className="relative h-48 w-full overflow-hidden" data-id="element-191">
                <div className={`absolute inset-0 bg-gradient-to-br ${niche.gradient} z-10 opacity-80 group-hover:opacity-60 transition-opacity duration-500`} data-id="element-192"></div>
                <div className="absolute inset-0 bg-circuit opacity-30 z-0" data-id="element-193"></div>

                {/* Image or tech overlay pattern */}
                {niche.image ? <img src={niche.image} alt={niche.title} className="absolute inset-0 w-full h-full object-cover z-0" data-id="element-194" /> : <div className="absolute inset-0 z-20" style={{
              backgroundImage: 'radial-gradient(rgba(255,255,255,0.1) 1px, transparent 1px)',
              backgroundSize: '10px 10px'
            }} data-id="element-195"></div>}

                <div className="absolute top-4 left-4 z-30 bg-petrol/80 backdrop-blur-sm p-2 rounded-lg border border-turquoise/20" data-id="element-196">
                  {niche.icon}
                </div>
              </div>

              <div className="p-8 flex-grow flex flex-col" data-id="element-197">
                <h3 className="text-2xl font-bold mb-3 text-white group-hover:text-turquoise transition-colors" data-id="element-198">
                  {niche.title}
                </h3>
                <p className="text-silver leading-relaxed flex-grow" data-id="element-199">
                  {niche.description}
                </p>

                <div className="mt-6 pt-6 border-t border-petrol-lighter flex items-center text-sm text-turquoise font-medium opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300" data-id="element-200">
                  Ver Soluciones <span className="ml-2" data-id="element-201">→</span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} className="text-center max-w-3xl mx-auto bg-petrol p-8 rounded-xl border border-turquoise/10 shadow-[inset_0_0_20px_rgba(0,212,170,0.02)] relative" data-id="element-202">
          <div className="absolute -top-3 -left-3 w-6 h-6 border-t-2 border-l-2 border-turquoise/50" data-id="element-203"></div>
          <div className="absolute -bottom-3 -right-3 w-6 h-6 border-b-2 border-r-2 border-turquoise/50" data-id="element-204"></div>
          <p className="text-xl text-silver-light font-medium leading-relaxed" data-id="element-205">
            "No usamos plantillas. Diseñamos sistemas que resuelven las
            necesidades específicas de tu profesión."
          </p>
        </FadeIn>
      </div>
    </section>;
}